import { writable } from 'svelte/store';
export const selectedProduct = writable({});
export const loadingChange = writable(false);
export const loadingCancel = writable(false);
export const ordersAwaitRefetch = writable(false);
export const defaultPaymentMethod = writable({});
